import * as React from "react";

function SvgPlanetUranus(props) {
  return (
    <svg viewBox="0 0 149.9 166.19" {...props}>
      <defs>
        <radialGradient
          id="planet-uranus_svg__d"
          cx={-1405.69}
          cy={881.66}
          r={71.6}
          gradientTransform="matrix(.03 -.89 .91 -.16 -729.28 -1055.27)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#f4f4f4" />
          <stop offset={1} />
        </radialGradient>
        <radialGradient
          id="planet-uranus_svg__f"
          cx={-1405.69}
          cy={881.66}
          r={71.6}
          gradientTransform="matrix(.03 -.89 .91 -.16 -729.28 -1055.27)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.23} stopColor="#fff" />
          <stop offset={1} stopColor="#f3f9f7" />
        </radialGradient>
        <filter
          id="planet-uranus_svg__a"
          x={12.62}
          y={-8177.15}
          width={78.53}
          height={32766}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <filter
          id="planet-uranus_svg__c"
          x={12.62}
          y={23.17}
          width={78.53}
          height={77.76}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodColor="#fff" result="bg" />
          <feBlend in="SourceGraphic" in2="bg" />
        </filter>
        <linearGradient
          id="planet-uranus_svg__g"
          x1={61.3}
          y1={73.41}
          x2={96.24}
          y2={98.24}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0} stopColor="#6a7cc0" />
          <stop offset={1} stopColor="#fff" />
        </linearGradient>
        <mask
          id="planet-uranus_svg__e"
          x={12.62}
          y={23.17}
          width={78.53}
          height={77.76}
          maskUnits="userSpaceOnUse"
        >
          <g
            mask="url(#planet-uranus_svg__b)"
            filter="url(#planet-uranus_svg__c)"
          >
            <path
              d="M28 37.12c16.6-16 43.21-19.12 57.16-4.78s1.26 27.26-14.66 47C57.43 95.62 35 109.21 21 94.89s-9.7-41.77 7-57.77z"
              style={{
                mixBlendMode: "multiply",
              }}
              fill="url(#planet-uranus_svg__d)"
            />
          </g>
        </mask>
      </defs>
      <g data-name="Layer 2">
        <circle
          cx={73.11}
          cy={81.42}
          r={66.02}
          transform="rotate(-45 73.105 81.419)"
          fill="#4bbbff"
        />
        <path
          d="M23.32 38.18a54.51 54.51 0 11-3.5 4.39 66.12 66.12 0 103.5-4.39z"
          fill="#4faecf"
        />
        <path
          d="M28.75 130.3c.11.11.22.22.34.32A66 66 0 00133 53.59l-.55-1.14c-.2-.42-.41-.82-.62-1.23A66.8 66.8 0 00118 33.13c-.29-.28-.4 0-.7-.28a68.77 68.77 0 01-8.08 83c-21.11 22.64-54.05 27.46-80.47 14.45z"
          fill="#1a5dad"
        />
        <path
          d="M23.9 37.41a65.94 65.94 0 00-13.28 22.65 87.64 87.64 0 0034.49-16.9 87.7 87.7 0 0022.51-27.51A65.78 65.78 0 0023.9 37.41zM84.85 16.46a45.32 45.32 0 01-9.95 14.65C69.12 37 62.32 41.86 56 47.18 42.71 58.3 31 71.94 15.05 78.75A29.92 29.92 0 017.1 81 66.44 66.44 0 008 92.45c8-1.86 15.33-6.65 21.44-12.25 8.36-7.66 15.11-17 23.56-24.51C60.64 48.87 69.49 43.56 77.31 37c6.14-5.17 11.77-11.44 14.86-18.75a64.39 64.39 0 00-7.32-1.79zM121 36c-1.23-1.3-2.52-2.57-3.88-3.79-.25-.23-.52-.44-.78-.66a286.28 286.28 0 01-40.47 40.5 9.86 9.86 0 01-3.77 2.22 3.43 3.43 0 01-3.84-1.42c-1.23-2.36 1.67-5.07 1.18-7.7-.44-2.35-3.53-3.36-5.79-2.54s-3.83 2.82-5.34 4.68a123.06 123.06 0 01-47.63 35.6 65.64 65.64 0 006.88 14.22 225.33 225.33 0 0032.19-26.76 16.78 16.78 0 00-.31 5.9 5.72 5.72 0 003.45 4.51c2.67.92 5.43-1 7.63-2.73C83.15 79.85 106.44 60.84 121 36z"
          fill="#75d2ff"
        />
        <path
          d="M111 27.35a66.47 66.47 0 00-6.07-3.78 253.79 253.79 0 01-32.82 32.12 6.18 6.18 0 00-1.9 2.11 2.06 2.06 0 00.57 2.57c.9.55 2 0 3-.48A124.71 124.71 0 00111 27.35z"
          fill="#75d2ff"
        />
        <path
          d="M89.22 134.26c-1.42 1.32-3.79 2.6-5 1.12-.91-1.08-.31-2.71.35-4a77.78 77.78 0 018.92-13.22c1.6-1.92 3.33-3.83 4.13-6.19s.35-5.36-1.73-6.73c-2.85-1.89-6.57.19-9.33 2.21l-29 21.33c-5.17 3.8-10.51 7.68-16.25 10.49a65.48 65.48 0 0023.8 7.67 60.77 60.77 0 0013.37-3.8c10-4.11 18.89-10.48 27.18-17.41a222.31 222.31 0 0032.59-33.68 66 66 0 00.75-14.24 365.65 365.65 0 01-49.78 56.45z"
          fill="#3c9fe1"
        />
        <path
          d="M80.07 15.79l-1.54-.16c-5.39 9.89-14.84 17.17-23 25.09-9.22 8.91-17.58 19.4-29.38 24.38a48.9 48.9 0 01-17.8 3.49c-.22 1.14-.42 2.27-.58 3.41a52.81 52.81 0 0023.09-8.24c5-3.31 9.46-7.46 13.86-11.58l18.62-17.46A120.65 120.65 0 0076.49 21a50.34 50.34 0 003.58-5.21zM98.35 24.41A10.88 10.88 0 0099.76 21l-1.35-.58c-2.52 6-7.16 11.12-12.24 15.31-6.09 5-12.93 9.07-19 14.13-1.93 1.61-3.78 3.31-5.63 5a3.18 3.18 0 00-1.1 1.55c-.13.64.31 1.42 1 1.37a1.61 1.61 0 00.87-.48l30.61-27.05a27.33 27.33 0 005.43-5.84z"
          fill="#75d2ff"
        />
        <path
          d="M138.41 71.8c-4.38 8.39-11.55 15.31-18.3 22.13Q106.79 107.4 94.67 122c-1.89 2.28-3.83 4.82-4.53 7.61a.92.92 0 001.56.84c14.65-16 29.28-32 42.59-49.11a46.68 46.68 0 004.49-6.62c-.1-.96-.22-1.94-.37-2.92z"
          fill="#3c9fe1"
        />
        <path
          d="M76.36 120.13a174.53 174.53 0 01-31.59 21 66.53 66.53 0 0023.78 6.12c-1.28-3 .77-6.8 2.79-9.45l9.51-12.46a9.38 9.38 0 001.9-3.38 3.19 3.19 0 00-1.17-3.45c-1.67-.97-3.72.37-5.22 1.62zM45 107.88c-2.31-1-5.05-.42-7.24.83a33.24 33.24 0 00-5.8 4.81 59.53 59.53 0 01-11.16 8.1 66.84 66.84 0 005.46 6.26c6.98-6.07 14.24-12.04 18.74-20z"
          fill="#75d2ff"
        />
        <path
          d="M111.39 89.67c-3 3.19-6.48 7.11-5.49 11.41l30.71-31.37c.41-.42.82-.85 1.22-1.28a66.41 66.41 0 00-2.69-9.62 182.72 182.72 0 01-23.75 30.86z"
          fill="#3c9fe1"
        />
        <path
          d="M99.49 80.5c-7.83 5.84-17.12 9.35-25.64 14.13a96.41 96.41 0 00-32.29 29.61 1.33 1.33 0 001.78 1.89c6.45-3.69 11.71-9.47 17.42-14.38 11.55-9.93 25.47-16.63 38.05-25.23s24.33-20 28-34.79a34.34 34.34 0 001-7.2q-1.53-2.27-3.26-4.41c-4.5 15.63-12.12 30.72-25.06 40.38zM88.37 101.45A161.9 161.9 0 0057.65 122c-1 .86-2 1.74-3 2.62-5.41 4.69-11 9.48-17.16 12.34.42.27.83.51 1.25.77 6.05-2.95 11.44-7.61 16.72-12.18l3-2.61a161.35 161.35 0 0130.49-20.41c1.49-.77 6.51-3 8.57-.18l1-.72c-1.8-2.46-5.59-2.53-10.15-.18z"
          fill="#75d2ff"
        />
        <path
          d="M93.63 107c-1.44-1-3.4-.13-4.89.78a116.5 116.5 0 00-14.87 10.77c3-1.8 6.45-3.66 9.91-3a7.31 7.31 0 015.15 4.16 16.9 16.9 0 005.48-8c.52-1.63.59-3.71-.78-4.71zM100.41 53.22C93 60.32 85 66.89 78.24 74.59c-.79.89-1.49 2.44-.49 3.09.64.42 1.49 0 2.15-.37 16.33-9.79 28.81-24.9 39.17-40.87q.48-.73.9-1.5c-.85-.85-1.72-1.69-2.62-2.51-4.3 7.83-10.46 14.57-16.94 20.79zM14 110.84a19.72 19.72 0 006.9-2.93c12.56-7.65 22.63-18.72 31.88-30.15a101.85 101.85 0 01-41.26 27.46c.75 1.9 1.57 3.78 2.48 5.62zM83 125.73c0-1.21-.33-2.61-1.43-3.11a3.63 3.63 0 00-3.14.54c-3.39 1.88-6.22 4.59-9.26 7a60.48 60.48 0 01-23.53 11.31 66.07 66.07 0 0017.52 5.21c2-1.85 3.54-4.19 5.52-6.08 2.58-2.46 5.86-4 8.72-6.17s5.44-5.14 5.6-8.7zM77.05 35.72c5.22-4.72 9.86-10.23 12.32-16.79.16-.45.32-.9.45-1.37-1.14-.3-2.28-.56-3.43-.8A46.51 46.51 0 0181.12 27c-8.53 12.47-22.45 19.91-33.79 29.86a94.15 94.15 0 00-18 21.29 185 185 0 0131.05-29.64C66 44.3 71.83 40.39 77.05 35.72zM99.71 37.32c-4.1 3.6-8.6 6.86-11.91 11.21a92 92 0 0023.08-21.23c-.75-.53-1.5-1-2.27-1.53-1.71 4.55-5.21 8.31-8.9 11.55zM56 24.89a79.42 79.42 0 01-15.38 12.57A37 37 0 0121.77 43l17.08-12.23q-6.76 2.32-13.39 5c-.53.54-1.05 1.08-1.56 1.65a65.62 65.62 0 00-8.37 11.72A55.61 55.61 0 0056 24.89zM85.73 90.56a18.6 18.6 0 01-12.49 9.68c.84-2.56 3.11-4.38 5.46-5.71s4.9-2.31 7.03-3.97zM83.37 80.17a2.34 2.34 0 002.82-2.12c.08-.75-.85-1.12-1.41-.81l-2.27 1.23c-1.07.58-.12 2.2.94 1.62l2.27-1.23-1.41-.81a.44.44 0 01-.44.31c-1.18-.2-1.69 1.64-.5 1.81zM83.87 50.1l-2.1 1.69c-.59.48-.18 1.36.42 1.57A2 2 0 0084.78 52a.94.94 0 00-1.81-.5c-.06.22-.18.13-.28.09l.41 1.57 2.1-1.69a.94.94 0 000-1.33 1 1 0 00-1.33-.04zM90.09 43.09a3.78 3.78 0 002.37-1.78 1 1 0 00-1.06-1.38 4.63 4.63 0 00-2.4 1.78c-.69 1 .93 1.93 1.63.95a2.39 2.39 0 011.24-.92l-1.06-1.38a1.9 1.9 0 01-1.25.92c-1.14.29-.64 2.1.53 1.81zM46.62 89.52a4.9 4.9 0 002.1-2.31 1 1 0 00-.81-1.41 2 2 0 00-1.86 1c-.66 1 1 2 1.62.95.07-.11.07-.08.24-.07l-.81-1.41a3.32 3.32 0 01-1.43 1.64.94.94 0 00.95 1.61zM54.8 78.74l1.48-1.34c.91-.81-.43-2.14-1.32-1.33l-1.49 1.34c-.9.81.43 2.13 1.33 1.33zM59.51 73.19l.59-.66c.81-.9-.52-2.24-1.32-1.33l-.59.66c-.81.9.52 2.23 1.32 1.33zM45.45 126.07l1.37-.54c1.11-.44.63-2.26-.5-1.81l-1.37.54c-1.12.45-.63 2.26.5 1.81zM52.56 120.58a2.5 2.5 0 002.15-1.35c.55-1.07-1.07-2-1.62-.94a.65.65 0 01-.53.41c-1.2.09-1.21 1.97 0 1.88zM59.36 115.41l.3-.33c.8-.9-.52-2.23-1.33-1.32l-.3.32c-.8.92.52 2.24 1.33 1.33zM106.24 100.77l.29-.33c.81-.9-.52-2.24-1.32-1.33l-.3.33c-.8.9.52 2.23 1.33 1.33zM112.29 89l.76-.5c1-.65.07-2.28-1-1.62l-.76.49c-.97.69-.03 2.31 1 1.63zM115.49 77.7l.92-.36c1.12-.42.64-2.24-.49-1.81l-.93.36c-1.12.43-.63 2.24.5 1.81z"
          fill="#a8daff"
        />
        <path
          d="M115.09 76.24a1.67 1.67 0 00-.6 2.21.93.93 0 001.47.19l1-1.15c.81-.9-.52-2.23-1.32-1.32-.34.38-.69.76-1 1.15l1.48.19c0 .11 0 .23-.08.35.96-.69.04-2.32-.95-1.62zM118 73.1l.6-.36a.94.94 0 00-1-1.62l-.6.36a.94.94 0 001 1.62z"
          fill="#a8daff"
        />
        <path
          d="M118.27 72.42l.29-.33c.81-.9-.52-2.23-1.33-1.33l-.29.33c-.81.91.52 2.23 1.33 1.33zM121.58 68.25a.94.94 0 000-1.88.94.94 0 000 1.88zM72 140l1-.84a.94.94 0 000-1.33 1 1 0 00-1.33 0l-1 .85a.93.93 0 000 1.32 1 1 0 001.33 0zM77.86 137l.89-.69a.94.94 0 10-1-1.62l-.89.69a.94.94 0 101 1.62zM82.37 132.74l.74-.82c.8-.9-.52-2.23-1.33-1.33l-.74.82c-.8.9.52 2.23 1.33 1.33zM34.2 71.53l.24-1.26c.23-1.18-1.58-1.69-1.81-.5L32.39 71c-.22 1.22 1.61 1.72 1.81.53zM25.2 78.08l1.06-.54c1.08-.55.13-2.17-.94-1.62l-1.06.54c-1.08.54-.13 2.16.94 1.62zM37.88 66.57l.59-.66c.8-.9-.52-2.23-1.33-1.33l-.59.66c-.8.9.52 2.23 1.33 1.33zM18.64 78.69l.77-.48c1-.64.08-2.26-.95-1.62l-.77.48c-1.03.63-.09 2.26.95 1.62zM47.49 37l.59-.66c.81-.9-.52-2.23-1.33-1.33l-.59.66c-.8.85.52 2.19 1.33 1.33zM52.29 33.24l.15-.16c.8-.9-.52-2.23-1.33-1.33l-.15.17c-.8.9.52 2.23 1.33 1.32zM56.26 28.8l.45-.49c.8-.9-.52-2.23-1.33-1.33l-.44.49c-.81.9.52 2.24 1.32 1.33zM72.37 65.43l.59-.65c.81-.9-.51-2.24-1.32-1.33l-.59.66c-.81.89.52 2.23 1.32 1.32z"
          fill="#a8daff"
        />
        <path
          d="M122.31 125.44A66 66 0 0072 15.43a65.24 65.24 0 11-44.34 113.85c.47.45.94.91 1.43 1.34a66 66 0 0093.22-5.18z"
          fill="#fff"
          opacity={0.24}
        />
        <path
          d="M78.94 88.23C97.28 68.76 104 42.71 95.5 19.32a66 66 0 00-82.43 89.56c23.67 6.21 47.93-1.6 65.87-20.65z"
          fill="#fff"
          opacity={0.15}
        />
        <g mask="url(#planet-uranus_svg__e)">
          <path
            d="M28 37.12c16.6-16 43.21-19.12 57.16-4.78s1.26 27.26-14.66 47C57.43 95.62 35 109.21 21 94.89s-9.7-41.77 7-57.77z"
            opacity={0.39}
            fill="url(#planet-uranus_svg__f)"
          />
        </g>
        <path
          d="M137.72 1.48a57.46 57.46 0 00-7.42 3.71 166.48 166.48 0 00-18.54 13c-2.15 1.72-4.36 3.55-6.63 5.46.38.21.77.41 1.15.63 2.09-1.79 4.15-3.5 6.14-5.11a146.83 146.83 0 0118.32-12.88A54.44 54.44 0 01138 2.71c9-3.49 12.13-.13 9.69 8.76a53.22 53.22 0 01-2.88 7.53 148.6 148.6 0 01-11.08 19.46 408.1 408.1 0 01-5 7.38c-3.68 5.16-7.73 10.7-12.24 16.43-6.67 8.49-14.15 17.5-22.3 26.84s-17 19-26.43 28.62c-7.51 7.74-15.46 15.48-23.87 22.89-2.12 1.86-4.25 3.71-6.43 5.53a159 159 0 01-17 12.56 53.47 53.47 0 01-9.15 4.75 19.54 19.54 0 01-4.67 1.22c-5.44.62-6.06-4.24-4.72-9.54a56.65 56.65 0 013.58-9.68A159.22 159.22 0 0115.89 127c1.36-2.13 2.75-4.22 4.16-6.29-.26-.35-.5-.72-.75-1.07-1.51 2.25-3 4.51-4.46 6.81-1.89 3-3.74 6.05-5.48 9.16s-3.45 6.25-4.95 9.48a57.85 57.85 0 00-3.73 10c-1.61 6.27-.61 11.69 5.81 11.07a20.56 20.56 0 005.09-1.23 61.82 61.82 0 009.56-4.7c3.07-1.81 6-3.81 9-5.86s5.79-4.18 8.6-6.36c2.61-2 5.16-4.1 7.68-6.19 8.35-7 16.26-14.25 23.77-21.55 9.73-9.57 18.72-19.2 26.9-28.69s15.54-18.73 22-27.51c4-5.51 7.76-10.82 11.1-15.87q3-4.5 5.53-8.7a164.18 164.18 0 0010.66-20.06 58.71 58.71 0 002.78-7.83C151.93.7 146.91-2.12 137.72 1.48z"
          fill="url(#planet-uranus_svg__g)"
        />
      </g>
    </svg>
  );
}

export default SvgPlanetUranus;
